import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';

import Grid from '../../components/cms/grid';
import AddNewButton from '../../components/cms/grid/addNewButton';

const initCriteria = {
  id: '',
  sortBy: 'id',
  order: 'desc',
};

const Items = ({ t, getColumns, service }) => (
  <div>
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-star" /> {t('Animations list')}</strong>
          </CardHeader>
          <CardBody>
            <div className="pull-right mb-1">
              <AddNewButton
                to={service.getCreateUrl()}
                permissionToCreate={service.getCreatePermissions()}
              />
            </div>
            <Grid
              id="payment-orders"
              service={service}
              columns={getColumns(t)}
              initCriteria={initCriteria}
              saveFilter={false}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Items.propTypes = {
  t: PropTypes.func.isRequired,
  getColumns: PropTypes.func.isRequired,
};

export default Items;



// WEBPACK FOOTER //
// ./src/views/animationsLists/Items.jsx